// EditDeleteKundenPage.jsx
import React from "react";
import {
    Box,
    Paper,
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Stack,
    Divider,
    IconButton,
} from "@mui/material";
import { ReactComponent as DeleteOutlineIcon } from "../../assets/DeleteSvg.svg";
import { ReactComponent as OpenNewSvg } from "../../assets/OpenNew.svg";

import { ReactComponent as BackSvg } from "../../assets/BackSvg.svg";

import {
    useForm,
    FormProvider,
    Controller,
} from "react-hook-form";
import GoBack from "../../components/GoBack";

const COUNTRIES = ["Deutschland", "Österreich", "Schweiz"];
const STATUS = ["aktiviert", "deaktiviert"];

const defaultValues = {
    customer: {
        name: "DELTA Tech",
        displayName: "",
        status: "aktiviert",
    },
    invoice: {
        company: "DELTA Tech System GmbH",
        addressLine2: "",
        street: "Lange Straße 123",
        country: "Deutschland",
        zip: "13049",
        city: "Berlin",
        email: "invoice@deltatech.com",
        info: "Auftrag 247UT0484332-A",
    },
};

export default function EditDeleteKundenPage() {
    const methods = useForm({ mode: "onChange", defaultValues });
    const { control, handleSubmit, watch } = methods;

    const [showHeartbeat, setShowHeartbeat] = React.useState(false);

    const onSave = (data) => {
        // TODO: wire to API
        // eslint-disable-next-line no-console
        console.log("SAVE KUNDEN:", data);
    };

    const onDelete = () => {
        const ok = window.confirm(
            "Sind Sie sicher? Das Löschen ist dauerhaft und entfernt alle Kundendaten."
        );
        if (ok) {
            // TODO: call delete API
            // eslint-disable-next-line no-console
            console.log("DELETE KUNDE:", watch());
        }
    };

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            setShowHeartbeat(true);
            setTimeout(() => {
                setShowHeartbeat(false);
            }, 1000);
        }, 1000);

    }

    return (
        <Box sx={{ p: 0 }} className="editDeleteKunden">
            <FormProvider {...methods}>

                <GoBack icon={<BackSvg />} text={"Kunde DELTA Tech"} color="rgba(0, 0, 0, 0.50)" to={"/kunden-dashboard"} />
                <br />
                <br />

                {/* Header card */}
                <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, borderColor: "#E6E8EB" }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                        <Typography sx={{ fontSize: 20, fontWeight: 500, color: "var(--color-primary)" }}>
                            Kunde {watch("customer.name") || "—"} bearbeiten
                        </Typography>

                        <Button
                            variant="outlined"
                            startIcon={<OpenNewSvg />}
                            onClick={() => console.log("Go to customer profile")}
                            sx={{ textTransform: "none", letterSpacing: "1.25px" }}
                        >
                            &nbsp;ZUM KUNDENPROFIL
                        </Button>
                    </Stack>

                    <Grid container spacing={2.5} style={{ paddingRight:"19%"}}>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="customer.name"
                                control={control}
                                rules={{ required: "Pflichtfeld" }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Kundenname (Unternehmen)"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message || 'Anzeigename, z. B.: "AUDI"'}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} className={showHeartbeat ? "animate__heartBeat" : ""}>
                            <Controller
                                name="customer.status"
                                control={control}
                                render={({ field }) => (
                                    <TextField {...field} select fullWidth label="Kundenstatus">
                                        {STATUS.map((s) => (
                                            <MenuItem key={s} value={s}>
                                                {s}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="customer.displayName"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Anzeigename"
                                        placeholder='z. B.: "AUDI"'
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Billing address card */}
                <Paper
                    variant="outlined"
                    sx={{ p: 2.5, mt: 3, borderRadius: 2, borderColor: "#E6E8EB" }}
                >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, color: "var(--color-primary)", mb: 2 }}>
                        Rechnungsadresse
                    </Typography>

                    <Grid container spacing={2.5} style={{ paddingRight:"19%"}}>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="invoice.company"
                                control={control}
                                rules={{ required: "Pflichtfeld" }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Unternehmen"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="invoice.addressLine2"
                                control={control}
                                render={({ field }) => (
                                    <TextField {...field} fullWidth label="Adresszusatz (optional)" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Controller
                                name="invoice.street"
                                control={control}
                                rules={{ required: "Pflichtfeld" }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Straße und Hausnummer"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="invoice.country"
                                control={control}
                                rules={{ required: "Pflichtfeld" }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        select
                                        fullWidth
                                        label="Land"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    >
                                        {COUNTRIES.map((c) => (
                                            <MenuItem key={c} value={c}>
                                                {c}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Controller
                                name="invoice.zip"
                                control={control}
                                rules={{
                                    required: "Pflichtfeld",
                                    pattern: { value: /^[0-9A-Za-z -]{3,10}$/, message: "Ungültige PLZ" },
                                }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="PLZ"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Controller
                                name="invoice.city"
                                control={control}
                                rules={{ required: "Pflichtfeld" }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Ort"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Controller
                                name="invoice.email"
                                control={control}
                                rules={{
                                    required: "Pflichtfeld",
                                    pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Ungültige E-Mail-Adresse" },
                                }}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        type="email"
                                        fullWidth
                                        label="E-Mail-Adresse"
                                        error={!!fieldState.error}
                                        helperText={fieldState.error?.message}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="invoice.info"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Rechnungsinformationen"
                                        placeholder="z. B.: Bestellnummer, etc."
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Danger zone */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        mt: 3,
                        borderRadius: 2,
                    }}
                >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, color: "#FF3D00", mb: 1 }}>
                        Kunde dauerhaft löschen
                    </Typography>
                    <Typography className="textSecondary" sx={{ mb: 2, width: "80%" }}>
                        Wenn Sie einen Kunden dauerhaft löschen, werden alle Kundendetails, Maschinen,
                        Standorte, Nachrichten zwischen Ihnen und dem Kunden, etc. gelöscht. Tipp:
                        Kunden können auch „deaktiviert“ werden, ohne diese endgültig zu löschen
                        (siehe dazu: <strong style={{ fontWeight: 500, color: "#38748D", cursor: "pointer" }} onClick={handleClick}>Kundenstatus</strong>).
                    </Typography>

                    <Button
                        variant="outlined"
                        color="error"
                        startIcon={<DeleteOutlineIcon />}
                        onClick={onDelete}
                        sx={{ textTransform: "none" , margin: "10px 0", letterSpacing: "1.25px"  }}
                    >
                        KUNDE DAUERHAFT LÖSCHEN
                    </Button>
                </Paper>

                {/* Footer */}
                <Box sx={{ my: 4 }}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(onSave)}
                        sx={{ bgcolor: "var(--color-primary)", "&:hover": { bgcolor: "#0b3140" }, textTransform: "none" }}
                    >
                        ÄNDERUNGEN SPEICHERN
                    </Button>
                </Box>
            </FormProvider>
        </Box>
    );
}
